import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "key-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M18.6586 5.34422C16.5387 3.21867 13.1 3.21849 10.9788 5.34429C9.41288 6.91396 9.00796 9.20465 9.75968 11.1576C9.86606 11.434 9.79984 11.7471 9.59067 11.9568L3.75 17.8107V20.25H6.18089L11.9976 14.4201C12.2095 14.2077 12.5275 14.142 12.8062 14.2531C14.7639 15.0336 17.0775 14.6327 18.6586 13.0479M19.7206 4.28484C17.0143 1.57162 12.624 1.57182 9.91696 4.28484C8.03924 6.16701 7.47391 8.85473 8.1985 11.2284L2.46907 16.9708C2.32878 17.1114 2.25 17.3019 2.25 17.5005V21C2.25 21.1989 2.32902 21.3897 2.46967 21.5303C2.61032 21.671 2.80109 21.75 3 21.75H6.49205C6.69126 21.75 6.88228 21.6707 7.02298 21.5297L12.7242 15.8155C15.1107 16.5711 17.8261 16.0062 19.7206 14.1072C22.4266 11.3941 22.4268 6.99712 19.7206 4.28484ZM18.6586 5.34422C20.7806 7.47082 20.7808 10.9201 18.6586 13.0479V5.34422Z"
    }, null, -1),
    _createElementVNode("path", { d: "M16.0774 9.07251C16.0774 9.6884 15.5781 10.1877 14.9622 10.1877C14.3463 10.1877 13.847 9.6884 13.847 9.07251C13.847 8.45662 14.3463 7.95734 14.9622 7.95734C15.5781 7.95734 16.0774 8.45662 16.0774 9.07251Z" }, null, -1)
  ])))
}
export default { render: render }